import React from 'react';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import { Provider } from 'react-redux';
import store from './redux/store';
import { render } from 'react-dom';
import getData from './data-services/api';
import AppProvider from './components/AppProvider/AppProvider';
import { initializeFirebase, askForPermissioToReceiveNotifications } from './utils/firebase';
import checkAppVersion from './utils/checkAppVersion';
import Dashboard from './containers/Dashboard';
import client from './utils/apolloClient';
import loadComponent from './utils/loadComponent';
import ListOutlet from './pages/Outlet/ListOutlet';
import AddEditOutlet from './pages/Outlet/AddEditOutlet';
import ListWorkshopsAMMD from './pages/AMMD/ListWorkshopsAMMD';
import ListTTCApprovalAMMD from './pages/AMMD/ListTTCApprovalAMMD';
import gql from 'graphql-tag';
import {
    NotFound,
    BackendError,
    ForgetPassword,
    Lockscreen,
    PasswordReset,
    AddParticipants,
    AddPhotos,
    PlanningWorkshop,
    Workshop,
    ListLead,
    Lead,
    ViewFCPLeads,
    ViewFCP,
    ViewWorkshopDetails,
    CreateContainer,
    ViewContainer,
    ListWorkshopCMDI,
} from './pages';
import ensureAuthenticated from './utils/ensureAuthenticated';
import { getUser } from './data-services/queries/index';
import BirthdayInfo from './pages/Home/BirthdayInfo';
import FevicyrlContent from './pages/Pages/FevicyrlContent';
import ImageSlider from './components/ImageSlider';
import FevicrylDetails from './pages/Pages/FevicrylDetails';
import ETTCUpload from './pages/Pages/ETTCUpload';
import ListETTCSubmissions from './pages/ETTCSubmission/ListETTCSubmissions';
import ListETTCEvaluations from './pages/ETTCSubmission/ListETTCEvaluations';
import ETTCSubmissionForm from './pages/ETTCSubmission/ETTCSubmissionForm';
import {
    ListETTCFcpsCMDI,
    ListETTCFcpsAMMD,
} from './pages/ETTCSubmission/ListETTCFcps';
import ListETTCCmdis from './pages/ETTCSubmission/ListETTCCmdis';
import ListETTCSubmissionsForFcp from './pages/ETTCSubmission/ListETTCSubmissionsForFcp';
import PaymentSummary from './pages/Profile/PaymentSummary';
import SuperAdmin from './pages/SuperAdmin/SuperAdmin';
import UserLists from './pages/SuperAdmin/UserLists';
import WorkshopList from './pages/SuperAdmin/WorkshopList';
import WorkshopDetails from './pages/SuperAdmin/WorkshopDetails';
import ViewUploads from './pages/Content/ViewUploads.js';

const Reports = loadComponent({ loader: () => import('./pages/AMMD/Reports') });
const PDFViewer = loadComponent({
    loader: () => import('./components/PDFViewer'),
});
const ListAssignLead = loadComponent({
    loader: () => import('./pages/AMMD/ListAssignLead'),
});
const AssingedHPA = loadComponent({
    loader: () => import('./pages/FCP/AssingedHPA'),
});
const PreviewWorkshop = loadComponent({
    loader: () => import('./pages/Pages/PreviewWorkshop'),
});
const ListTraining = loadComponent({
    loader: () => import('./pages/Training/ListTraining'),
});
const Training = loadComponent({
    loader: () => import('./pages/Training/Training'),
});
const AddTrainingPhotos = loadComponent({
    loader: () => import('./pages/Training/AddTrainingPhotos'),
});
const ListMyFCP = loadComponent({
    loader: () => import('./pages/MyFCP/ListMyFCP'),
});
const MyFCP = loadComponent({ loader: () => import('./pages/MyFCP/MyFCP') });
const AddFCPHPA = loadComponent({
    loader: () => import('./pages/FCP/AddFCPHPA'),
});
const AddNewHPA = loadComponent({
    loader: () => import('./pages/FCP/AddNewHPA'),
});
const ListHPA = loadComponent({
    loader: () => import('./pages/HPA/HPAList.js'),
});
const AddNewSchool = loadComponent({
  loader: () => import("./pages/School/AddNewSchool.js")
});
const SchoolList = loadComponent({
  loader: () => import("./pages/School/SchoolList.js")
});
// const Reports = loadComponent({ loader: () => import("./pages/Pages/Reports") });
const ListPayments = loadComponent({
    loader: () => import('./pages/Payments/ListPayments'),
});
const ListPaymentsAMMD = loadComponent({
    loader: () => import('./pages/AMMD/ListPaymentsAMMD'),
});
const Content = loadComponent({
    loader: () => import('./pages/Content/Content'),
});

const TrainingModules = loadComponent({
    loader: () => import('./pages/Content/TrainingModules'),
});

const FeviArtMagazines = loadComponent({
    loader: () => import('./pages/Content/FeviArtMagazines'),
});

const ProductWiseApplications = loadComponent({
    loader: () => import('./pages/Content/ProductWiseApplications/ProductWiseApplications'),
});
const AcrylicColours = loadComponent({
    loader: () => import('./pages/Content/ProductWiseApplications/AcrylicColours'),
});
const GlassColours = loadComponent({
    loader: () => import('./pages/Content/ProductWiseApplications/GlassColours'),
});
const ModgePodge = loadComponent({
    loader: () => import('./pages/Content/ProductWiseApplications/ModgePodge'),
});
const Mouldit = loadComponent({
    loader: () => import('./pages/Content/ProductWiseApplications/Mouldit'),
});
const PearlMetallic = loadComponent({
    loader: () => import('./pages/Content/ProductWiseApplications/PearlMetallic'),
});
const ThreeDOutliner = loadComponent({
    loader: () => import('./pages/Content/ProductWiseApplications/ThreeDOutliner'),
});

const ContentForSchool = loadComponent({
    loader: () => import('./pages/Content/ContentForSchool'),
});
const AIMBedCurriculum = loadComponent({
    loader: () => import('./pages/Content/AIMBedCurriculum'),
});
const ProductTraining = loadComponent({
    loader: () => import('./pages/Content/ProductTraining'),
});
const ApplicationVideos = loadComponent({
    loader: () => import('./pages/Content/ApplicationVideos'),
});
const BrandVideos = loadComponent({
    loader: () => import('./pages/Content/BrandVideos'),
});
const FeviSmart = loadComponent({
    loader: () => import('./pages/Content/FeviSmart'),
});
const ContentForCollege = loadComponent({
    loader: () => import('./pages/Content/ContentForCollege'),
});

render(
    <Provider store={store}>
        <AppProvider>
            <BrowserRouter>
                <Switch>
                    <Route exact path="/404" component={NotFound} />
                    <Route exact path="/500" component={BackendError} />
                    <Route exact path="/ForgetPassword" component={ForgetPassword} />
                    {/* <Route
              path="/ForgetPassword"
              component={ ForgetPassword }
              loc="https://demohobbyideas.herokuapp.com/ForgetPassword/230425728-Privacy-Policies"
            /> */}
                    <Route exact path="/Lockscreen" component={Lockscreen} />
                    <Route exact path="/forgot" component={PasswordReset} />
                    <Route exact path="/signin" component={ForgetPassword} />
                    <Route exact path="/listAssignLead" component={ListAssignLead} />
                    <Route exact path="/addParticipants" component={AddParticipants} />
                    <Route exact path="/addPhotos" component={AddPhotos} />
                    <Route exact path="/planningWorkshop" component={PlanningWorkshop} />
                    <Route exact path="/previewWorkshop" component={PreviewWorkshop} />
                    <Route exact path="/workshop" component={Workshop} />
                    <Route exact path="/listLead" component={ListLead} />
                    <Route exact path="/lead" component={Lead} />
                    <Route exact path="/viewFCPLeads" component={ViewFCPLeads} />
                    <Route exact path="/listMyFCP" component={ListMyFCP} />
                    <Route exact path="/myFCP" component={MyFCP} />
                    <Route exact path="/assignedHPA" component={AssingedHPA} />
                    <Route exact path="/viewFCP" component={ViewFCP} />
                    <Route exact path="/createContainer" component={CreateContainer} />
                    <Route exact path="/viewContainer" component={ViewContainer} />
                    <Route exact path="/listWorkshopCMDI" component={ListWorkshopCMDI} />
                    <Route exact path="/reportsAMMD" component={Reports} />
                    <Route exact path="/listPayments" component={ListPayments} />
                    <Route exact path="/listPaymentsAMMD" component={ListPaymentsAMMD} />
                    <Route exact path="/listWorkshopsAMMD" component={ListWorkshopsAMMD} />
                    <Route exact path="/listTTCApprovalAMMD" component={ListTTCApprovalAMMD} />
                    <Route exact path="/listTraining" component={ListTraining} />
                    <Route exact path="/listMyFCP" component={ListMyFCP} />
                    <Route exact path="/training" component={Training} />
                    <Route exact path="/addFCPHPA" component={AddFCPHPA} />
                    <Route exact path="/addNewHPA" component={AddNewHPA} />
                    <Route exact path="/listHPA" component={ListHPA} />
                    <Route exact path="/addNewSchool" component={AddNewSchool} />
                    <Route exact path="/schoolList" component={SchoolList} />
                    <Route exact path="/content" component={Content} />
                    <Route exact path="/birthday-Info" component={BirthdayInfo} />
                    <Route exact path="/fevicryl-Content" component={FevicyrlContent} />
                    <Route exact path="/fevicryl-Details" component={FevicrylDetails} />
                    <Route exact path="/payment-Summary" component={PaymentSummary} />
                    <Route exact path="/ettc-Upload" component={ETTCUpload} />
                    <Route exact path="/ettc-submissions" component={ListETTCSubmissions} />
                    <Route exact path="/ettc-evaluations" component={ListETTCEvaluations} />
                    <Route exact path="/ettc-submission" component={ETTCSubmissionForm} />
                    <Route exact path="/ettc-cmdi-fcps" component={ListETTCFcpsCMDI} />
                    <Route exact path="/ettc-ammd-cmdis" component={ListETTCCmdis} />
                    <Route exact path="/ettc-ammd-fcps" component={ListETTCFcpsAMMD} />
                    <Route
                        exact
                        path="/ettc-fcp-submissions"
                        component={ListETTCSubmissionsForFcp}
                    />
                    <Route exact path="/super" component={SuperAdmin} />
                    <Route exact path="/Userlist" component={UserLists} />
                    <Route exact path="/Workshoplist" component={WorkshopList} />
                    <Route exact path="/viewUploads" component={ViewUploads} />
                    <Route exact path="/WorkshopDetails" component={WorkshopDetails} />
                    <Route exact path="/slider" component={ImageSlider} />
                    <Route exact path="/training-modules" component={TrainingModules} />
                    <Route exact path="/fevi-art-magazines" component={FeviArtMagazines} />
                    <Route
                        exact
                        path="/product-wise-applications"
                        component={ProductWiseApplications}
                    />
                    <Route exact path="/acrylic-colours" component={AcrylicColours} />
                    <Route exact path="/glass-colours" component={GlassColours} />
                    <Route exact path="/modge-podge" component={ModgePodge} />
                    <Route exact path="/mouldit" component={Mouldit} />
                    <Route exact path="/pearl-metallic" component={PearlMetallic} />
                    <Route exact path="/three-d-outliner" component={ThreeDOutliner} />

                    <Route exact path="/content-for-school" component={ContentForSchool} />
                    <Route exact path="/aim-bed-curriculum" component={AIMBedCurriculum} />
                    <Route exact path="/product-training" component={ProductTraining} />
                    <Route exact path="/brand-videos" component={BrandVideos} />
                    <Route exact path="/FeviSmart" component={FeviSmart} />
                    <Route exact path="/application-videos" component={ApplicationVideos} />
                    <Route exact path="/content-for-college" component={ContentForCollege} />
                    <Route exact path="/addTrainingPhotos" component={AddTrainingPhotos} />
                    <Route exact path="/pdfViewer" component={PDFViewer} />
                    <Route exact path="/listOutlet" component={ListOutlet} />
                    <Route exact path="/addEditOutlet" component={AddEditOutlet} />
                    <Route exact path="/viewWorkshopDetails" component={ViewWorkshopDetails} />
                    {/* <Route exact path="/profile" component={MyProfile} /> */}
                    <Route path="/" component={ensureAuthenticated(Dashboard)} />
                </Switch>
            </BrowserRouter>
        </AppProvider>
    </Provider>,
    document.getElementById('root')
);

// registerServiceWorker();
checkAppVersion();
document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') {
        checkAppVersion();
    }
});
initializeFirebase();

client
    .watchQuery({
        query: gql(getUser),
    })
    .subscribe(async ({ data }) => {
        if (data) {
            const user = data.user;
            // console.log('usersfid', user);
            if (user) {
                const r = await askForPermissioToReceiveNotifications();
                // If user exists send token to
                // check if device token exists in db or add the token to db
                if (r) {
                    if (user.role === 'FCP') {
                        //Select Device Token for FCP
                        const FCPToken = await getData(
                            `Select Id, devices_id__c , FCP__c from salesforce.Devices__c where fcp__c = '${user.sfid}' and devices_id__c='${r}'`
                        );

                        if (FCPToken && !FCPToken.result) {
                            // Insert Device Token for FCP
                            await getData(
                                `Insert into salesforce.Devices__c (devices_id__c, FCP__c) Values('${r}', '${user.sfid}') returning id`
                            );
                        }
                    }

                    if (user.role === 'CMDI' || user.role === 'AMMD') {
                        //Select Device Token for AMMD and CMDI
                        const CMDIAMMDToken = await getData(
                            `Select Id, devices_id__c ,  AMMD_or_CMDI__c  from salesforce.Devices__c where ammd_or_cmdi__c ='${user.sfid}' and devices_id__c='${r}'`
                        );
                        if (CMDIAMMDToken && !CMDIAMMDToken.result) {
                            // console.log("CMDIAMMDToken && !CMDIAMMDToken.result", CMDIAMMDToken.result)
                            //Insert Device Token for AMMD and CMDI
                            await getData(
                                `Insert into salesforce.Devices__c (devices_id__c, AMMD_or_CMDI__c)  Values('${r}','${user.sfid}') returning id`
                            );
                        }
                    }
                }

                //prefetch outlets data

                if (user.role === 'CMDI') {
                    //where CMDI_Name__c like '${user.sfid}'
                    getData(
                        `SELECT Id, sfid,active__c, WSS_CODE__c, Region__c, Cluster__c,
            TTY_Name__c,OutletName__c,tsi_tty_name__c, WSS_TTY_Name__c, 
            WSS_Name__c, Outletcode__c, Class_name__c, TTY_Code__c, Address__c, 
            City_Town__c FROM Salesforce.Outlets__c 
            WHERE CMDI_Name__c like '${user.sfid}' LIMIT 1000`
                    ).then((r) => {
                        localStorage.setItem('outlets', JSON.stringify(r.result ? r.result : null));
                    });
                } else {
                    // When Login user is FCP then
                    getData(
                        `SELECT Id, sfid,active__c, WSS_CODE__c, Region__c, Cluster__c,
            TTY_Name__c,OutletName__c,tsi_tty_name__c, WSS_TTY_Name__c, 
            WSS_Name__c, Outletcode__c, Class_name__c, TTY_Code__c, Address__c, 
            City_Town__c FROM Salesforce.Outlets__c 
            WHERE CMDI_Name__c like '${user.assigned_cmdi__c}' LIMIT 1000`
                    ).then((r) => {
                        localStorage.setItem('outlets', JSON.stringify(r.result ? r.result : null));
                    });
                }

                //prefetch articles data
                getData(
                    `SELECT id, name, cluster_Name__c, tsi_territory_code__c, tsi_tty_name__c, wss_tty_code__c 
            FROM salesforce.WSS_TTY_Mapping__c 
            WHERE assigned_cmdi__c LIKE '${user.sfid}' 
            ORDER BY tsi_tty_name__c ASC`
                ).then((r) => {
                    localStorage.setItem('WSS', JSON.stringify(r.result));
                });

                //prefetch articles data
                getData(
                    `Select  Active__c, Id, SFId, Name, MATERIAL_CODE__c, MATERIAL_NAME__c, PIL_Billing__c, MRP__c from salesforce.Article__c`
                ).then((r) => {
                    localStorage.setItem('articles', JSON.stringify(r.result));
                });
            }
        } else {
            console.log('User data is undefined');
        }
    });
navigator.geolocation.getCurrentPosition((position) => {
    localStorage.setItem('long', position.coords.longitude);
    localStorage.setItem('lat', position.coords.latitude);
});
